import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'brand-xing', 'BrandXing', [["path",{"d":"M16 21l-4 -7l6.5 -11","key":"svg-0"}],["path",{"d":"M7 7l2 3.5l-3 4.5","key":"svg-1"}]]);